import { Component, OnInit, ViewChild } from '@angular/core';
import { CUtilit } from 'src/app/classes/utilit';
import { CustomMatListComponent, ArmaWebTable } from 'src/app/components/custom-mat-list/custom-mat-list.component';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';

@Component({
  selector: 'app-query-editor',
  templateUrl: './query-editor.component.html',
  styleUrls: ['./query-editor.component.css']
})
export class QueryEditorComponent implements OnInit {

  @ViewChild('ArmaList', { static: true }) HTML_ArmaList!: CustomMatListComponent<any>;

  HTML_TextEditer: string;

  HTML_HttpRequestInProgress: boolean;

  HTML_caretPositionX: number;
  HTML_caretPositionY: number;

  private mAllArrayAutoCompletionWord: string[];
  HTML_ArrayValueAutoCompletion: string[];

  items = Array.from({length: 100000}).map((_, i) => `Item #${i}`);

  constructor(private mArmaServMethod: ArmaServServerMethods, private mToolbar: AppToolbarService) {
    this.HTML_TextEditer = '';
    this.HTML_ArrayValueAutoCompletion = [];
    this.mAllArrayAutoCompletionWord = [];
    this.HTML_HttpRequestInProgress = false;
    this.HTML_caretPositionX = 1;
    this.HTML_caretPositionY = 1;
  }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Query editor';
  }

  async executeQuerry() {
    if (!this.HTML_TextEditer) {
      console.error('Text vide');
      return;
    }
    if (this.HTML_HttpRequestInProgress) return;
    try {
      this.HTML_HttpRequestInProgress = true;
      // On crée le contenu qui sera dans la page qu'on va transmetre
      const body = { 'SQL': this.HTML_TextEditer };

      // On execute la requete et on attend le resultat
      const list: ArmaWebTable = await this.mArmaServMethod.getSQL(body);
      const arrayHeaderName: any[] = [];
      list.Header.forEach(header => {
        arrayHeaderName.push(header.Name);
      });
      this.HTML_ArmaList.setScroolHeight(48, 56);
      this.HTML_ArmaList.setHeader(arrayHeaderName, list.Header);
      this.HTML_ArmaList.setRows(list.Data);
    } catch (e) {
      console.error(e);
      alert(e.error.error); // ?
    } finally {
      this.HTML_HttpRequestInProgress = false;
    }
  }

  async searchForAutoCompletion() {
    try {
      const textAutoComplete = this.getTextForAutoComplete(); // On recupere le nom du cham ou table a chercher

      // Exec d'une requete rest....

      const body = {
        TableName: textAutoComplete.TableName,
        FieldName: textAutoComplete.FieldName,
        LFGFieldName: CUtilit.boolToStr(textAutoComplete.searchFieldName),
      };

      const arrayValue = await this.mArmaServMethod.getSQLAutoCompletion(body);

      this.showAutoCompleteValue(arrayValue);

    } catch (error) {
      console.error(error);
    } finally {

    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (!event) return;
    switch (event.key) {
      case 's':
      case 'S':
        if (event.ctrlKey) event.preventDefault();
        break;
      case ' ':
        if (event.ctrlKey) {
          this.searchForAutoCompletion();
        } else {
          this.mAllArrayAutoCompletionWord = [];
        }
        break;
      case 'Escape': this.mAllArrayAutoCompletionWord = []; break;
    }
    //console.log('event', event.key); // Affiche le nom de la key
  }

  onKeyUp(event: KeyboardEvent) {
    // Pour gerer le traitement de l'array mot autocompletion
    let wordFilter = '';
    if (this.mAllArrayAutoCompletionWord.length > 0) {
      const val = this.getTextForAutoComplete();
      if (val.searchFieldName) {
        wordFilter = val.FieldName;
      } else {
        wordFilter = val.TableName;
      }
    }

    this.HTML_ArrayValueAutoCompletion = this.mAllArrayAutoCompletionWord.filter(word => {
      return word.match(wordFilter);
    });
  }

  insertValue(value: string) {
    // On clear l'auto completion
    this.mAllArrayAutoCompletionWord = [];
    const textAutoComplete = this.getTextForAutoComplete();
    let charToInsert = '';
    if (textAutoComplete.searchFieldName) {
      charToInsert = value.slice(textAutoComplete.TableName.length, value.length);
    } else {
      charToInsert = value.slice(textAutoComplete.FieldName.length, value.length);
    }
    //textAutoComplete.
    this.inputTextArea.focus();
  }

  getTextForAutoComplete(): {TableName: string, FieldName: string, searchFieldName: boolean} {
    if (!this.HTML_TextEditer) this.HTML_TextEditer = '';
    let tableName = ''  ;
    let fieldName = '';
    let pointFieldName = false;

    const selectionStart = this.inputTextArea.selectionStart;

    const search = this.HTML_TextEditer.replace(/\n/g, ' '); // Pour recuperer le text area sans les retour à la ligne

    let field = '';
    let tmp = selectionStart - 1; // -1 pour ne pas prendre le char qui est appres le selector
    for (tmp ; tmp > 0 ; tmp--) {
      if (search.charAt(tmp) == ' ') break;
      if (search.charAt(tmp) == '.') pointFieldName = true;
    }

    field += search.slice(tmp, selectionStart).trim(); // On ajoute le début du text au field

    tmp = selectionStart; // Reutlisation de la variable tmp
    for (tmp ; tmp < search.length ; tmp++) {
      if (search.charAt(tmp) == ' ') break;
      if (search.charAt(tmp) == '.') pointFieldName = false;
    }

    field += search.slice(selectionStart, tmp).trim();

    const splitField = field.split('.');
    if (splitField.length > 0) tableName = splitField[0];
    if (splitField.length > 1) fieldName = splitField[1];

    console.log({
      'TableName': tableName ? tableName : '',
      'FieldName': fieldName ? fieldName : '',
      'poingFieldName': pointFieldName
    });

    return {
      'TableName': tableName ? tableName : '',
      'FieldName': fieldName ? fieldName : '',
      'searchFieldName': pointFieldName
    };
  }

  showAutoCompleteValue(listAutoComplete: string[]) {
    const cursorXY = getCursorXY(this.inputTextArea, this.inputTextArea.selectionStart);
    const correctX = 0;
    const correctY = 10;
    this.HTML_caretPositionX = cursorXY.x + (correctX);
    this.HTML_caretPositionY = cursorXY.y + (correctY);

    this.mAllArrayAutoCompletionWord = listAutoComplete;
  }

  public get inputTextArea(): HTMLTextAreaElement {
    return <HTMLTextAreaElement> document.getElementById('queryTextArea');
  }

}

/**
 * Source: https://medium.com/@jh3y/how-to-where-s-the-caret-getting-the-xy-position-of-the-caret-a24ba372990a
 * Ajusté pour respecter le ts
 *
 * returns x, y coordinates for absolute positioning of a span within a given text input
 * at a given selection point
 * @param input - object - the input element to obtain coordinates for
 * @param selectionPoint - number - the selection point for the input
 */
const getCursorXY = (input: any, selectionPoint: any) => {
  const {offsetLeft: inputX, offsetTop: inputY} = input;
  // create a dummy element that will be a clone of our input
  const div = document.createElement('div');
  // get the computed style of the input and clone it onto the dummy element
  const copyStyle = getComputedStyle(input);
  //console.log('copyStyle', copyStyle);

  for (let i = 0; i < copyStyle.length; i++) {
    const prop = copyStyle.item(i);
    // @ts-ignore
    div.style[prop] = copyStyle[prop];
  }
  // we need a character that will replace whitespace when filling our dummy element if it's a single line <input/>
  const swap = '.';
  const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
  // set the div content to that of the textarea up until selection
  const textContent = inputValue.substr(0, selectionPoint);
  // set the text content of the dummy element div
  div.textContent = textContent;
  if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
  // if a single line input then the div needs to be single line and not break out like a text area
  if (input.tagName === 'INPUT') div.style.width = 'auto';
  // create a marker element to obtain caret position
  const span = document.createElement('span');
  // give the span the textContent of remaining content so that the recreated dummy element is as close as possible
  span.textContent = inputValue.substr(selectionPoint) || '.';
  // append the span marker to the div
  div.appendChild(span);
  // append the dummy element to the body
  document.body.appendChild(div);
  // get the marker position, this is the caret position top and left relative to the input
  const { offsetLeft: spanX, offsetTop: spanY } = span;
  // lastly, remove that dummy element
  // NOTE:: can comment this out for debugging purposes if you want to see where that span is rendered
  document.body.removeChild(div);
  // return an object with the x and y of the caret. account for input positioning so that you don't need to wrap the input
  console.log('X: ' + inputX + spanX + ' ; Y: ' + inputY + spanY);
  return {x: inputX + spanX, y: inputY + spanY};
};
